import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/company';

export class CompanyService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  async createDesignDemoLicense(params: types.CreateDesignDemoLicenseParameters): Promise<void> {
    await this.axios.post<types.CreateDesignDemoLicenseParameters>(
      `/companies/${params.path.companyId}/licenses`,
    );
  }

  getDesignToolSeats(
    params: types.GetDesignToolSeatsParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    throw new Error('Method not implemented.');
  }
  async createDesignToolSeat(
    params: types.CreateDesignToolSeatParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    const result = await this.axios.post<types.GetDesignToolSeatsResponse>(
      `/companies/${params.path.companyId}/design-tool-seat`,
      params.body,
    );

    return result.data;
  }
  async deleteDesignToolSeat(params: types.DeleteDesignToolSeatParameters): Promise<void> {
    await this.axios.delete<types.DeleteDesignToolSeatParameters>(
      `/companies/${params.path.companyId}/design-tool-seat/${params.path.designToolSeatId}`,
    );
  }
  async patchDesignToolSeat(
    params: types.PatchDesignToolSeatParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    const result = await this.axios.patch<types.GetDesignToolSeatsResponse>(
      `/companies/${params.path.companyId}/design-tool-seat/${params.path.designToolSeatId}`,
      params.body,
    );

    return result.data;
  }
  createCompany(params: types.CreateCompanyParameters): Promise<types.CreateCompanyResponse> {
    throw new Error('Method not implemented.');
  }
  async fetchProjectCompany(
    params: types.FetchProjectCompanyParameters,
  ): Promise<types.ProjectCompanyResponse> {
    const { data } = await this.axios.get<types.ProjectCompanyResponse>(
      `/companies/fetchProjectCompany?id=${params.query.id}`,
    );
    return data;
  }
  async fetchAllCompanies(
    params: types.FetchAllCompaniesParameters,
  ): Promise<types.CompaniesResponse> {
    const { data } = await this.axios.get<types.CompaniesResponse>('companies/fetchCompanies');
    return data;
  }
  async fetchUserCompanies(
    params: types.FetchUserCompaniesParameters,
  ): Promise<types.UserCompaniesResponse> {
    const { data } = await this.axios.get<types.UserCompaniesResponse>(
      `/companies/fetchUserCompanies?id=${params.query.id}`,
    );
    return data;
  }
  async getCompanyAdminRequest(
    params: types.GetCompanyAdminRequestParameters,
  ): Promise<types.CompanyAdminRequestResponse> {
    const { data } = await this.axios.get<types.CompanyAdminRequestResponse>(
      `companies/getcompanyadminrequest?requestId=${params.query.requestId}`,
    );
    return data;
  }
  async inviteCompanyAdmin(
    params: types.InviteCompanyAdminParameters,
  ): Promise<types.InviteCompanyAdminRequestResponse> {
    const { data } = await this.axios.post(`companies/invitecompanyadmin`, params.body, {
      headers: { ...params.headers },
    });
    return data;
  }
  async register(params: types.RegisterParameters): Promise<types.SuccessResponse> {
    const { data } = await this.axios.post(`companies/register`, params.body);
    return data;
  }
  async verifyCompanyAdmin(
    params: types.VerifyCompanyAdminParameters,
  ): Promise<types.VerifyCompanyAdminResponse> {
    const { data } = await this.axios.put<types.VerifyCompanyAdminResponse>(
      `companies/user/verification/${params.path.token}`,
      params.body,
    );
    return data;
  }
  // The body form of the HEAD below: same route, but it also says whether this invitation is
  // completed with the new sign-in, which decides whether the form asks for a password.
  async isCompanyUserVerified(
    params: types.IsCompanyUserVerifiedParameters,
  ): Promise<types.IsCompanyUserVerifiedResponse> {
    const { data } = await this.axios.get<types.IsCompanyUserVerifiedResponse>(
      `companies/user/verification/${params.path.token}`,
    );
    return data;
  }
  async headRegistrationToken(
    params: types.HeadRegistrationTokenParameters,
  ): Promise<types.SuccessResponse> {
    const { data } = await this.axios.head<types.SuccessResponse>(
      `companies/user/verification/${params.path.token}`,
    );
    return data;
  }

  async deleteCompanyAdmin(params: types.DeleteCompanyAdminParameters): Promise<void> {
    await this.axios.delete<types.SuccessResponse>(
      `companies/${params.path.companyId}/users/${params.path.userId}`,
    );
  }

  async getCompanies(): Promise<types.GetCompaniesResponse> {
    const response = await this.axios.get<types.GetCompaniesResponse>(`/companies`);
    return response.data;
  }

  async getCompany(params: types.GetCompanyParameters): Promise<types.GetCompanyResponse> {
    const response = await this.axios.get<types.GetCompanyResponse>(
      `/companies/${params.path.companyId}`,
    );
    return response.data;
  }
}
